import React, { useEffect, useRef, useState } from 'react';
import { AppWindow, ArrowRight, Globe, Laptop, Mail, Megaphone, Phone, Send, ChevronDown, Eye, ArrowUpRight, MessageCircle, PenTool, BarChart2, Heart, Play } from 'lucide-react';
import { Button } from '@radix-ui/themes';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import Typed from "typed.js";
import TestimonialsSection from '../components/testimonials/TestimonialsSection';
import { Link } from 'react-router-dom';
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import SpriteScrollAnimation from '../components/home/PaperHome';

export default function Works() {
    const [playingVideo, setPlayingVideo] = useState(null);

    const videos = [
        {
            video_url: '/works/videos/super-vadapav-1.mp4',
            thumbnail_url: '/works/videos/super-vadapav-1-thumbnail.webp',
        },
        {
            video_url: '/works/videos/oesten-spaces-1.mp4',
            thumbnail_url: '/works/videos/oesten-spaces-1-thumbnail.webp',
        },
        {
            video_url: '/works/videos/kidzee-1.mp4',
            thumbnail_url: '/works/videos/kidzee-1-thumbnail.webp',
        }
    ]

    const handleVideoClick = (index) => {
        setPlayingVideo(index);
    };

    const handleVideoEnd = (index) => {
        setPlayingVideo(null);
    };

    return (
        <>
            <section className="">
                <h1 className='text-3xl md:text-center md:text-6xl font-extrabold'>
                    Lights<span className='text-brand-orange'>.</span> Camera<span className='text-brand-orange'>.</span>  Scroll<span className='text-brand-orange'>.</span>
                </h1>
                <p className='font-poppins font-medium md:text-xl mt-4 md:text-center'>Reel moments that make real impact.</p>
                <div className="mt-8 md:mt-20">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
                        {videos.map((video, index) => (
                            <div key={index} className='relative cursor-pointer group'>
                                {playingVideo === index ? (
                                    <video
                                        className='block rounded-lg w-full h-auto'
                                        playsInline
                                        src={video.video_url}
                                        autoPlay
                                        controls
                                        preload="metadata"
                                        onEnded={() => handleVideoEnd(index)}
                                        onLoadStart={() => console.log(`Video ${index + 1} started loading`)}
                                        onCanPlay={() => console.log(`Video ${index + 1} can start playing`)}
                                        onError={(e) => console.error(`Video ${index + 1} error:`, e)}
                                    >
                                        <source src={video.video_url} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                ) : (
                                    <div 
                                        className='relative rounded-lg overflow-hidden'
                                        onClick={() => handleVideoClick(index)}
                                    >
                                        <img 
                                            src={video.thumbnail_url}
                                            alt={`Video ${index + 1} thumbnail`}
                                            className='block rounded-lg w-full h-auto transition-transform duration-300 group-hover:scale-105'
                                            onError={(e) => {
                                                console.error(`Thumbnail ${index + 1} failed to load:`, e);
                                                // Fallback to video poster or default image
                                                e.target.style.display = 'none';
                                            }}
                                        />
                                        {/* Play button overlay */}
                                        <div className='absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 group-hover:bg-opacity-50 transition-all duration-300'>
                                            <div className=' bg-black aspect-square bg-opacity-90 rounded-full p-4 group-hover:bg-opacity-100 transition-all duration-300 transform group-hover:scale-110'>
                                                <Play className='translate-y-0.5 w-8 h-8 text-gray-800 ml-1' fill="currentColor" />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}